<template>
  <Teleport to="body">
    <Transition name="dq-loader-fade">
      <div
        v-if="visible"
        class="dq-premium-loader"
        role="status"
        aria-live="polite"
        aria-busy="true"
        aria-label="Loading DoneQuick"
      >
        <div class="dq-premium-loader__panel">
          <div class="dq-premium-loader__brand">
            <img :src="logoUrl" alt="" />
          </div>

          <div class="dq-premium-loader__orbits" aria-hidden="true">
            <span class="dq-premium-loader__ring dq-premium-loader__ring--outer"></span>
            <span class="dq-premium-loader__ring dq-premium-loader__ring--mid"></span>
            <span class="dq-premium-loader__ring dq-premium-loader__ring--inner"></span>
          </div>

          <h1 class="dq-premium-loader__title">
            Done<span>Quick</span>
          </h1>
          <p class="dq-premium-loader__subtitle">HR &amp; Payroll</p>

          <div class="dq-premium-loader__track" aria-hidden="true">
            <div class="dq-premium-loader__bar"></div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script setup>
import { computed } from "vue";
import { storeToRefs } from "pinia";
import { useAppLoaderStore } from "@/stores/appLoaderStore";

const loader = useAppLoaderStore();
const { visible } = storeToRefs(loader);

const logoUrl = computed(() => `${process.env.BASE_URL}favicon.png`);
</script>

<style>
@import "@/assets/css/premium-loader.css";

.dq-loader-fade-enter-active,
.dq-loader-fade-leave-active {
  transition: opacity 0.45s cubic-bezier(0.22, 1, 0.36, 1);
}

.dq-loader-fade-enter-from,
.dq-loader-fade-leave-to {
  opacity: 0;
}
</style>
